var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_108",
    "data-name": 108,
    className: "cls-2",
    d: "M12,96.84c-3.12-2.73-2.27-8-1.24-11.49,4.15-14.13,11.52-27.59,17.86-40.82C45.85,8.52,47.11,3.41,53.51,2.15c17.1-3.38,40.18,26.72,34.91,37.4-1.62,3.27-5.65,4-8.88,4.64-5,1-10,1.58-14.61,3.7C57.6,51.25,54.14,58.4,50.81,65.28c-3.9,8-8,16.82-14.92,22.91C31.77,91.8,17.41,101.59,12,96.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat108);
export default __webpack_public_path__ + "static/media/cat_108.21873792addfd7505169a78effa37c1d.svg";
export { ForwardRef as ReactComponent };